var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C12.3774 0 16 3.54717 16 8C16 12.5283 10.566 19.8491 8 24C5.43396 19.8491 0 12.5283 0 8C0 3.54717 3.54717 0 8 0ZM8 2.56604C11.0189 2.56604 13.434 4.98113 13.434 8C13.434 11.0189 11.0189 13.434 8 13.434C4.98113 13.434 2.56604 11.0189 2.56604 8C2.56604 4.98113 4.98113 2.56604 8 2.56604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinWhite);
export default __webpack_public_path__ + "static/media/pinWhite.86bfc1de2bf55390438a6aecffc48b34.svg";
export { ForwardRef as ReactComponent };